import Service from "../Service";
import AccountService from "./AccountService";
import PersistentData from "../PersistentData";
import ClinicService from "./ClinicService";

const serve = new Service();
const account = new AccountService();

async function SavePrefs(clinicId, prefs) {
    const { data } = serve.request('Clinic/' + (clinicId || account.clinicId), {
        put: {
            preferences: JSON.stringify(prefs)
        }
    })
    console.log('Save Prefs:', data);
}

async function GetPrefs(clinicId) {
    const { preferences } = await serve.request('Clinic/' + (clinicId || account.clinicId));
    try{
        return JSON.parse(preferences || '{}');
    } catch (e) {
        return {};
    }
}

export default class Preferences {

    static GetClinicPref(pref, clinicId) {
        console.log('** GetClinicPrefs Preferences:',  ClinicService.GetCache(clinicId).getData('preferences'));
        const preferences =  ClinicService.GetCache(clinicId).getData('preferences') || {};

        return preferences[pref];
    }

    static async SetClinicPref(pref, value, clinicId) {
        const preferences = await GetPrefs(clinicId);
        preferences[pref] = value;
        ClinicService.GetCache(clinicId).setData('preferences', preferences);
        await SavePrefs(clinicId, preferences);
    }
}



// WEBPACK FOOTER //
// ./src/api/services/Preferences.js